import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta18ExemplosEnum,
  ConsultaSeguimentoPergunta18Model,
} from './model-consultaSeguimentoPergunta18'

const pergunta18ExemplosEnum = Object.values(ConsultaSeguimentoPergunta18ExemplosEnum)

export const isPergunta18ExemplosAllNao = (
  value: ConsultaSeguimentoPergunta18Model['PERGUNTA_18_EXEMPLOS']
): boolean => {
  return isAllNao(value, pergunta18ExemplosEnum)
}
